<template>
	<article class="content list-page">
		<header>
			<h1>Security</h1>
			<p class="gray-6">Manage your security settings to keep your account secure.</p>
		</header>

		<section>
			<h3>Sign In</h3>
			<div v-if="showValidationMessage" class="notice row baseline above relative">
				<spinner-new v-if="verifyingEmail"></spinner-new>
				<!-- <i class="fas fa-exclamation-triangle rigid"></i> -->
				<div class="flexible">
					<h3>Unverified Email</h3>
					<p>We noticed your email address has not been verified. <span v-if="!requestFailed"> <button class="link"  @click="verifyEmail()" href="#">Verify it now</button>.</span></p>
					<p v-if="requestFailed">An error occurred. Please <button class="link" @click="verifyEmail()">try again</button> or <a href="mailto:support@support.tekcloud.com?subject=Verify%20Email%20Error">contact support</a>.</p>
				</div>
			</div>
			<div v-if="showResentMessage" class="notice above success relative">
				<spinner-new v-if="verifyingEmail"></spinner-new>
				<div class="rigid">
					<h3>Verification Email Sent</h3>
					<p>Click the link included to verify your email address. If you didn't get an email, <button class="link" @click="verifyEmail()">try again</button>.</p>
				</div>
			</div>
			
			<security-partial></security-partial>
		</section>

		<section class="list-group">
			<h3>Account</h3>
			<close-account-partial></close-account-partial>
		</section>
	</article>
</template>

<script>
// import SettingToggle from '../components/SettingToggle';
import SettingToggle from '../components/SettingToggle';
import Spinner from '../components/Spinner';
import SpinnerNew from '../components/SpinnerNew';
import SecurityPartial from '@/views/Security.partial';
import CloseAccountPartial from '@/views/CloseAccount.partial';
import consentService from '@/modules/consent-service';
import userService from '@/modules/user-service';
import { mapGetters, mapState, mapActions } from 'vuex';

export default {
	name: 'Security',
	computed: {
		...mapGetters([
			'user',
			'userStatus'
		]),
		...mapGetters('consent', [
			'showConsentNotice',
			'marketingEnabled'
		]),
		...mapState('consent', [
			'marketingEnabledAnswer'
		]),
		showValidationMessage() {
			return this.userStatus.success && !this.user.emailVerified && !this.requestSent;
		},
		showResentMessage() {
			return !this.user.emailVerified && this.requestSent;
		}
	},
	data() {
		return {
			password: '',
			loadingMarketingFlag: false,
			requestSent: false,
			verifyingEmail: false,
			requestFailed: false
		};
	},
	components: {
		SettingToggle,
		SecurityPartial,
		CloseAccountPartial,
		Spinner,
		SpinnerNew
	},
	methods: {
		...mapActions('consent',{
			setMarketingFlag: 'SET_MARKETING_ANSWER'
		}),
		toggleDataCollection(enabled) {
			this.$store.dispatch('RESET_USER_STATUS');
			this.updateDataCollection(enabled);
		},
		toggleMarketingOptIn(enabled) {
			this.$store.dispatch('RESET_USER_STATUS');
			const answer = enabled ? 'yes' : 'no';
			consentService.setMarketingFlag(answer)
				.then(() => {
					this.setMarketingFlag(answer);
				});
		},
		updateDataCollection(enabled) {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('UPDATE_USER_REQUEST', {
					trackingEnabled: enabled
				})
					.catch(reason => {
						reject(reason);
					});
			});
		},
		verifyEmail() {
			const vm = this;
			vm.verifyingEmail = true;
		
			userService.verifyEmail()
				.then(() => {
					vm.requestSent = true;
					vm.verifyingEmail = false;
					this.exponentialBackoff(userService.getEmailVerified, 40, 2000, function(result) {
						vm.$store.dispatch('SET_EMAIL_VERIFIED', result);
					});
				})
				.catch(err => {
					vm.verifyingEmail = false;
					vm.requestFailed = true;
				});
		},
		resetState() {
			this.$store.dispatch('RESET_USER_STATUS');
		},
		exponentialBackoff(getInfo, max, delay, callback) {
			const vm = this;
			getInfo(true)
				.then(function(emailVerified){
					if (emailVerified) {
						callback(emailVerified);
					} else {
						if (max > 0) {
							setTimeout(function() {
								vm.exponentialBackoff(getInfo, --max, delay + 1000, callback);
							}, delay);
						} else {
							console.log('Giving up...');   
						}
					}
				})
				.catch(function(error) {
					//this.getInfoError = error;
					callback(false);
				});
		}
	},
	created(){
		let vm = this;
		if (!this.marketingEnabledAnswer && this.$root.isTek) {
			consentService.getMarketingFlag()
				.then((answer) => {
					vm.setMarketingFlag(answer);
				});
		}

	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// ./src/views/Security.vue